import { RAlertSeverity } from '#ds-types'

import type { MessageProps } from 'primevue/message'

export default {
  closeButton: () => ({
    class: [
      // Flexbox
      'flex items-center justify-center',

      // Size
      'w-7 h-7',

      // Spacing and Misc
      'ml-auto relative',

      // Shape
      'rounded-full',

      // Transitions
      'transition duration-200 ease-in-out',

      // Misc
      'overflow-hidden',
    ],
  }),
  content: {
    class: [
      // Flexbox
      'flex items-center h-full',

      // Spacing
      'py-4 px-2 gap-2',

      // Sizing
      'text-sm',
    ],
  },
  icon: {
    class: [
      // Sizing and Spacing
      'flex-shrink-0 w-[1.125rem] h-[1.125rem]',
    ],
  },
  root: ({ props }: { props: MessageProps }) => ({
    class: [
      // Spacing and Shape
      'rounded-md',

      // Colors
      /* eslint-disable eqeqeq */
      {
        'bg-blue-50': props.severity == RAlertSeverity.Info,
        'bg-green-50': props.severity == RAlertSeverity.Success,
        'bg-orange-50': props.severity == RAlertSeverity.Warn,
        'bg-red-50': props.severity == RAlertSeverity.Error,
        'bg-surface-50':
          props.severity == RAlertSeverity.Secondary || !props.severity,
      },

      // Border
      'outline outline-1',
      {
        'outline-blue-600': props.severity == RAlertSeverity.Info,
        'outline-green-600': props.severity == RAlertSeverity.Success,
        'outline-orange-600': props.severity == RAlertSeverity.Warn,
        'outline-red-600': props.severity == RAlertSeverity.Error,
        'outline-surface-600':
          props.severity == RAlertSeverity.Secondary || !props.severity,
      },
      {
        'text-blue-700 dark:text-blue-300': props.severity === 'info',
        'text-green-700 dark:text-green-300': props.severity === 'success',
        'text-orange-700 dark:text-orange-300': props.severity === 'warn',
        'text-red-700 dark:text-red-300': props.severity === 'error',
        'text-surface-0 dark:text-surface-950': props.severity === 'contrast',
        'text-surface-700 dark:text-surface-300':
          props.severity === 'secondary',
      },
      /* eslint-enable eqeqeq */
    ],
  }),
  text: {
    class: [
      // Font and Text
      'text-sm leading-normal',
      'font-medium',
    ],
  },
  transition: {
    enterActiveClass: 'transition-opacity duration-300',
    enterFromClass: 'opacity-0',
    leaveActiveClass: 'overflow-hidden transition-all duration-300 ease-in',
    leaveFromClass: 'max-h-40',
    leaveToClass: 'max-h-0 opacity-0 !m-0',
  },
}
